<template>
  <div class="betting-container">
    <tabs>
      <tab
        name="tab_betting"
        selected="true">
        <div class="tab-details">
          <div class="betting-balls">
            <div class="future-bets">
              <futurebets />
            </div>
            <div class="balls-container">
              <ball
                v-for="ball in balls"
                :key="ball.number"
                :ball="ball" />
            </div>
          </div>
          <div class="additional-betting">
            <div class="system-betting">
              <button
                class="btn system-btn"
                :disabled="isBettingDisabled('system')"
              >
                <span>{{ 'select_system' | translate }}</span>
                <span v-if="bettingSvc.type == 'system' ||  gameSvc.spotNumber < bettingSvc.ticket.input.length">
                  {{ setActiveSystem }}
                </span>
              </button>
              <button
                class="btn popup-btn"
                :disabled="isBettingDisabled('system')"
                @click="openModal('system')">
                <span class="n-i n-i-arrow-down-a" />
              </button>
            </div>
            <div class="random-betting">
              <button
                class="btn random-btn"
                @click="selectRandom()">
                {{ setRandomLabel }}
              </button>
              <button
                class="btn popup-btn"
                @click="openModal('random')">
                <span class="n-i n-i-arrow-down-a" />
              </button>
            </div>
            <div
              class="all-in-betting"
              v-if="'i' in specialBets && specialBets.i.active"
            >
              <button
                id="41"
                class="btn all-in-btn"
                @click="specialClick"
                :class="{ 'active': bettingSvc.specialBetsActiveStatus[41] }"
                :disabled="isBettingDisabled('allIn')"
              >
                {{ gameConfig.bets[41].name }}
              </button>
            </div>
            <div
              class="no-draw-betting"
              v-if="'u' in specialBets && specialBets.u.active"
            >
              <button
                id="40"
                class="btn no-draw-btn"
                @click="specialClick"
                :class="{ 'active': bettingSvc.specialBetsActiveStatus[40] }"
                :disabled="isBettingDisabled('noDraw')"
              >
                {{ gameConfig.bets[40].name }}
              </button>
            </div>
          </div>
          <div class="paytable">
            <paytable />
          </div>
        </div>
      </tab>

      <tab
        name="tab_special"
        v-if="specialBetsFiltered">
        <div class="tab-details">
          <div
            class="special-bet"
            v-for="(bet, index) in specialBetsFiltered"
            :key="index"
          >
            <div class="special-bet-name">
              {{ bet.name }}
            </div>
            <div class="special-actions clearfix">
              <div
                :class="`action action-${bet.actions.length}`"
                v-for="(action, index) in bet.actions"
                :key="index"
                :id="`choice-${index}-betId-${bet.id}`"
                @click="selectChoice(bet, index)"
              >
                <div class="span-wrap">
                  <span class="middle">
                    {{ action.info.split(' - ')[1] }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </tab>
    </tabs>

    <modal
      v-if="isModalVisible"
      :type="type" />
  </div>
</template>

<script>
import { translate } from '../../../filters/translate';
import Tabs from "../../common/Tabs.vue";
import Tab from "../../common/Tab.vue";
import Ball from "../../common/Ball.vue";
import Paytable from "../../common/PayTable.vue";
import Futurebets from "../../common/FutureBets.vue";
import Modal from "../../common/Modal.vue";
import { GameSvc } from "../../../services/game.service";
import { BettingSvc } from "../../../services/betting.service";
import { PaytableSvc } from "../../../services/paytable.service";
import { EventBus } from "../../../utilities/event.bus";
import { TranslationSvc } from '../../../services/translation.service';

export default {
  name: "Betting",

  filters: {
    translate,
  },

  components: {
    Tab,
    Tabs,
    Ball,
    Modal,
    Paytable,
    Futurebets,
  },

  data() {
    return {
      balls: GameSvc.getGameSvc().balls,
      isModalVisible: false,
      type: "",
      bettingSvc: BettingSvc.getBettingSvc(),
      paytableSvc: PaytableSvc.getPaytableSvc(),
      gameConfig: sevenConfig.data.config,
      gameSvc: GameSvc.getGameSvc(),
      selectedBet: {
        choice: null,
      },
    };
  },

  created() {
    this.createSpecialBets();

    EventBus.$on("Keno.AddToBetslip", () => {
      let bettingSvc = BettingSvc.getBettingSvc();

      bettingSvc.finalizeTicket();
      GameSvc.getGameSvc().dactivateBalls();
      bettingSvc.clearAll();

      let choices = document.getElementsByClassName('action');
      for (let i = 0; i < choices.length; i += 1) {
        choices[i].classList.remove('selected');
      }
    });

    EventBus.$on("Modal.Close", () => {
      this.isModalVisible = false;
    });

    EventBus.$on("Keno.ClearBetting", () => {
      let bettingSvc = BettingSvc.getBettingSvc();
      bettingSvc.clearAll();
      this.clearSelectedChoices();
    });

    EventBus.$on("Keno.SelectSpecialBetting", (bet, choice) => {
      this.selectChoice(bet, choice);
    });

    EventBus.$on("Keno.ClearSpecialBettings", () => {
      this.clearSelectedChoices();
    });

    EventBus.$on("Keno.SpotNumberChanged", () => {
      this.bettingSvc.clearAll(true);
    });
  },

  methods: {
    specialClick(e) {
      this.bettingSvc.terminalSpecialBet(e, this.bettingSvc, 'click');
    },

    selectChoice(bet, choice) {

      this.bettingSvc.clearNumberBets();

      this.bettingSvc.terminalSpecialBet({target: { id: bet.id }, choice: choice + 1}, this.bettingSvc, 'click');

      this.setSelectedChoice(bet, choice);
    },

    setSelectedChoice(bet, choice) {
      const actionEls = document.getElementsByClassName('action');

      for (let i = 0; i < actionEls.length; i +=1) {
        if (`choice-${choice}-betId-${bet.id}` != actionEls[i].id) {
          actionEls[i].classList.remove('selected');
        }
      }

      for (let i = 0; i < actionEls.length; i += 1) {
        if (`choice-${choice}-betId-${bet.id}` == actionEls[i].id) {
            actionEls[i].classList.toggle('selected');

            if (!actionEls[i].classList.contains('selected')) {
              this.bettingSvc.clearAll();
            }
        }
      }
    },

    clearSelectedChoices() {
      const actionEls = document.getElementsByClassName('action');

      for (let i = 0; i < actionEls.length; i += 1) {
          actionEls[i].classList.remove('selected');
      }
    },

    createSpecialBets() {
      if (sevenConfig.data.config.bets) {
        this.bettingSvc.setSpecialBets(sevenConfig.data.config.bets);
      }
    },

    selectRandom() {
      if (this.bettingSvc.random) {
        this.bettingSvc.clearInput();
        this.bettingSvc.clearNumberBets();
        this.bettingSvc.clearSpecialBets();
        this.gameSvc.dactivateBalls();
        this.bettingSvc.selectRandomNumbers();
      }
    },

    openModal(type) {
      this.isModalVisible = true;
      this.type = type;

      for (let i in this.bettingSvc.specialBetsActiveStatus) {
        this.bettingSvc.specialBetsActiveStatus[i] = false;
      }
    },

    isValid(number1, number2) {
      let n1 = number1 || 1,
        n2 = number2 || n1;

      return this.paytableSvc.paytable[n1 + "_" + n2] !== undefined;
    },

    isBettingDisabled(betting) {
      let status = false;
      const numbersSelected = this.bettingSvc.ticket.input.length || 0;

      switch (betting) {
        case 'system':
          status = !this.isAnySystemAvailable();
          break;
        case 'allIn':
          status = !numbersSelected || numbersSelected > this.gameSvc.rules.maxAllInNumbers.value;
          break;
        case 'noDraw':
          status = !numbersSelected || numbersSelected > this.gameSvc.rules.maxNoDrawNumbers.value;
          break;
        default:
          break;
      }

      return status;
    },

    isAnySystemAvailable() {
      const numbersSelected = this.bettingSvc.ticket.input.length || 0;
      let isAvailable = false;

      for (let i = 1; i < numbersSelected; i++) {
        if (this.paytableSvc.paytable[i + '_' + numbersSelected] !== undefined) {
          isAvailable = true;
          break;
        }
      }

      return isAvailable;
    },
  },

  computed: {
    specialBets() {
      return this.bettingSvc.specialBets;
    },

    specialBetsFiltered() {
      let bets = {};

      if (Object.keys(this.bettingSvc.specialBets).length) {
        for (let i in this.bettingSvc.specialBets) {
          if (this.bettingSvc.specialBets[i].id != 40 && this.bettingSvc.specialBets[i].id != 41) {
            bets[i] = this.bettingSvc.specialBets[i];
          }
        }
      } else {
        bets = null;
      }

      return bets;
    },

    setActiveSystem() {
      if (this.bettingSvc.system)
        return (
          this.bettingSvc.system + "/" + this.bettingSvc.ticket.input.length
        );
    },

    setRandomLabel() {
      return (
        TranslationSvc.getTranslation('select_random') +
        " " +
        (this.isValid(this.bettingSvc.random) ? this.bettingSvc.random : "")
      );
    }
  }
};
</script>

<style  lang="scss">
$popup-btn-width: 48px;
$button-margin: 1px;

.middle {
  position: relative;
  display: block;
  top: 50%;
  transform: translateY(-50%);
}

.tab-details {
  width: 100%;
  height: auto;
  background-color: #242424;
  overflow: auto;

  .betting-balls {
    width: 61%;
    margin: 15px 0 15px 15px;
    float: left;

    .balls-container {
      height: 100%;
      width: 100%;
      margin-top: 20px;
    }
  }

  .additional-betting {
    position: relative;
    width: 35%;
    margin-top: 35px;
    float: right;

    .system-betting,
    .random-betting,
    .all-in-betting,
    .no-draw-betting {
      width: 65%;
      height: 50px;
      margin: 0 auto;
    }

    .system-btn,
    .random-btn,
    .all-in-btn,
    .no-draw-btn {
      color: #e6e6e6;
      background-color: #323232;
      text-align: left;
      float: left;
      margin-right: $button-margin;
      width: calc(96% - #{$popup-btn-width} - #{$button-margin});
    }

    .all-in-btn,
    .no-draw-btn {
      width: 96%;
      text-align: center;

      &.active {
        background: #0066ae;
      }
    }

    .btn[disabled] {
      opacity: .4;
      color: #777;
    }

    .popup-btn {
      width: $popup-btn-width;
      color: #e6e6e6;
      background-color: #323232;
      float: left;
    }
  }

  .paytable {
    width: 36%;
    height: 200px;
    float: right;
  }

  .future-bets {
    width: 100%;
    height: 50px;
  }

  .clearfix::after {
    content: "";
    clear: both;
    display: table;
  }

  .special-bet {
    margin: 10px 0;
    position: relative;
    float: left;
    width: 50%;

    .special-bet-name {
      text-align: center;
      margin: 15px 0;
      color: #efefef;
      font-size: 16px;
      font-weight: normal;
    }

    .special-actions {
      position: relative;
      width: 100%;


      .action {
        float: left;
        text-align: center;
        height: 50px;
        cursor: pointer;

        &.selected {
          background: #0066ae;

          .span-wrap {
            background: #0066ae;
          }
        }

        .span-wrap {
          position: relative;
          width: 95%;
          height: 100%;
          margin: 0 auto;
          background-color: #424242;
          color: #e6e6e6;
        }
      }

      .action-2 {
        width: 50%;
      }

      .action-3 {
        width: 33.33%;
      }

      .action-4 {
        width: 25%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Betting.vue?ca2bda06